import { render, staticRenderFns } from "./eboekhouden.vue?vue&type=template&id=4296868b&scoped=true&"
import script from "./eboekhouden.vue?vue&type=script&lang=js&"
export * from "./eboekhouden.vue?vue&type=script&lang=js&"
import style0 from "./eboekhouden.vue?vue&type=style&index=0&id=4296868b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4296868b",
  null
  
)

export default component.exports